<section>
  <div class="additional-info-container">
    <div class="d-flex align-items-center">
      <span>Please read and sign to the</span>
      <p-button
        #btnWaiverForm
        label="Substitue W9 Form."
        styleClass="btn-jot-form"
        iconPos="right"
        [link]="true"
        [loading]="btnWaiverForm.loading"
        (onClick)="getFormUrl(btnWaiverForm)"
      />
    </div>
    <div class="d-flex align-items-center gap-3 mt-6">
      <p-checkbox
        inputId="aggrementConfirmation"
        class="flex"
        [binary]="true"
        [(ngModel)]="aggrementConfirmation"
      />
      <label for="aggrementConfirmation" class="cursor-pointer">
        I have read and electronically signed the Substitue W9 Form.
      </label>
    </div>
  </div>
</section>

 <div class="alert alert-info mt-3">
      <p>Note: Clicking the button above will open a new page where you can digitally fill and sign the form. Once completed, you can return to this screen and continue.</p>
      <p>Important: If your browser requests permission to allow pop-ups from form.jotform.com, please click "Allow" to proceed.</p>
  </div>
